/*
 * @Author: Ryan
 * @Date: 2026-02-03
 * @Description: AI Image Enhancer 首屏图片对比展示器 - 使用通用 ImageCompareSlider 组件
 */
import React from 'react';

import ImageCompareSlider from '@/landing/components/ImageCompareSlider';

import { SHOWCASE_IMAGES } from './imageData';

interface ImageComparePlayerProps {
  className?: string;
}

const ImageComparePlayer: React.FC<ImageComparePlayerProps> = ({ className = '' }) => {
  return (
    <ImageCompareSlider
      images={SHOWCASE_IMAGES}
      defaultIndex={2}
      className={className}
      themeColor="#6366F1"
    />
  );
};

export default ImageComparePlayer;
